"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgRemove = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("g", { clipPath: "url(#remove_svg__clip0)" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M3.526 3.526a2.976 2.976 0 000 4.209L7.791 12l-4.265 4.265a2.976 2.976 0 104.209 4.21L12 16.208l4.265 4.265a2.976 2.976 0 004.21-4.209L16.209 12l4.265-4.265a2.976 2.976 0 00-4.209-4.21L12 7.792 7.735 3.526a2.976 2.976 0 00-4.209 0z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "remove_svg__clip0" },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" })))));
};
exports.default = SvgRemove;
//# sourceMappingURL=Remove.js.map